import {Settings} from "@mui/icons-material";
import {Button, Container, Drawer, Grid, Switch, Typography, useTheme} from "@mui/material";
import React, {useState} from "react";
import {setUserOption, userOptions} from "../../../user";
import {CrossIcon} from "./SvgIcons";
import {infoTooltip, Timezones} from "../../../dictionaries";
import {InfoTooltip} from "./Tooltip";
import FormSelect from "./FormSelect";
import {Title4, Title5} from "./Typography";
import {ButtonBase} from "./Button";
import {ThemeSwitcher} from "./ThemeSwitcher";

export function SettingsDrawer({closeOnBackdrop}) {
  const [drawerState, setDrawerState] = useState(false);

  const openDrawer = () => {
    setDrawerState(true);
  };

  const closeDrawer = () => {
    setDrawerState(false);
  };

  const onSwitch = (data) => {
    setUserOption(data.name, data.state);
  }

  const onThemeSwitch = (theme) => {
    setUserOption('theme', theme);
  }

  return [
    (<Drawer open={drawerState} anchor='right' ModalProps={{
      onBackdropClick: async () => {
        if (closeOnBackdrop)
          setDrawerState(false);
      }
    }}>
      <Container sx={{width: 500, padding: 1}}>
        <Grid container spacing={0} alignItems="center" justifyContent="center">
          <Grid item xs={11} display="inline">
            <Title4 title="Настройки"/>
          </Grid>

          <Grid item xs={1} display="inline"><ButtonBase variant="text" onClick={closeDrawer}><CrossIcon size={20}/></ButtonBase></Grid>
          <Grid item xs={12} sx={{height: '20px'}} display="inline"></Grid>
          <Grid item xs={12} display="inline">
            <Title4 title="Общие"/>
          </Grid>
          <SettingItemSwitch title='Открывать ссылки в текущей вкладке' name='openLinkCurrentTab' onSwitch={onSwitch} checked={userOptions.openLinkCurrentTab} infoTooltip={infoTooltip.OPEN_LINK_CUR_TAB}/>

          <Grid item xs={12} sx={{height: '5px'}} display="inline"></Grid>
          <Grid item xs={4} display="flex" sx={{paddingLeft: '10px'}}>
            <Title5 title="Часовой пояс"/>
          </Grid>
          <Grid item xs={8}  display="flex" justifyContent="flex-end">
            <FormSelect data={Timezones} onChange={(event)=>{
              setUserOption(event.target.name, event.target.value)
            }} value={userOptions?.timezone} size="small" name="timezone"/>
          </Grid>

          <Grid item xs={12} sx={{height: '5px'}} display="inline"></Grid>
          <Grid item xs={12} display="flex" sx={{paddingLeft: '10px'}}>
            <Title5 title="Темы"/>
          </Grid>
          <Grid item xs={12} sx={{height: '5px'}} display="inline"></Grid>
          <Grid item xs={8}  display="flex" justifyContent="flex-end">
            <ThemeSwitcher onSwitch={onThemeSwitch}/>
          </Grid>
        </Grid>
      </Container>
    </Drawer>),
    openDrawer,
    closeDrawer
  ]
}

export function SettingsButton({onClick}) {
  const theme = useTheme();

  return <ButtonBase variant="text" sx={{color: theme.palette.icon.default}} onClick={onClick ? onClick : void 0}>
    <Settings/>
  </ButtonBase>
}

export function SettingItemSwitch({title, checked, name, onSwitch, infoTooltip}) {
  const [switchState, setSwitchState] = useState(checked)

  const toggleSwitch = () => {
    if (switchState === true) {
      setSwitchState(false)
      onSwitch ? onSwitch({name, state: false}) : void 0;
    } else {
      setSwitchState(true)
      onSwitch ? onSwitch({name, state: true}) : void 0;
    }
  }

  return (
    <Grid container spacing={0} alignItems="center"
          sx={{
            '&:hover': {
              backgroundColor: '#F5F5F5FF',
              cursor: 'pointer',
            }
          }} onClick={toggleSwitch}>
      <Grid item xs={10} display="inline" sx={{display: "flex", paddingLeft: '10px'}}><Title5 title={title}/>{infoTooltip ? <InfoTooltip placement="bottom" sx={{paddingLeft: '4px', paddingTop: '3px'}} title={infoTooltip}/> : 0}</Grid>
      <Grid item xs={2} display="inline" sx={{paddingRight: '11px'}} display="flex" justifyContent="flex-end">
        <Switch checked={switchState}/></Grid>
    </Grid>
  )
}